// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"123":"6cbc0539","295":"8a8880f4","998":"96488dd6"}[chunkId] + ".js";
};